import { gql } from "@apollo/client";
export default gql`
  mutation GenerateDataToken($input: DelegationDataInputs!) {
    generateDataToken(input: $input)
  }
`;
